<template>
  <q-btn size="sm" round flat>
    <img src="/icons/copy.svg" alt="copy" style="width: 12px; height: 14px" />
    <slot />
  </q-btn>
</template>

<style scoped lang="scss"></style>
